import {
  Component,
  EventEmitter,
  Injector,
  Input,
  Output,
  OnInit,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AbstractValueAccessor, MakeProvider } from '../abstract-value-accessor';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-toggle-box',
  templateUrl: './toggle-box.component.html',
  styleUrls: ['./toggle-box.component.scss'],
  providers: [MakeProvider(ToggleBoxComponent)],
  standalone: false,
})
export class ToggleBoxComponent extends AbstractValueAccessor implements OnInit {
  @Input()
  title: string;

  @Input()
  subtitle: string;

  @Input()
  editable = true;

  @Input()
  iconSrc: string;

  @Input()
  comingSoon: boolean;

  @Input()
  tooltipText: string;

  @Input()
  shouldDisplayTooltip: boolean;

  @Output()
  changeValue = new EventEmitter<{ toggle: boolean }>();

  toggleControl = new UntypedFormControl(null);

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.toggleControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      if (this.editable) {
        this.value = value;
        this.markAsDirty();
        this.changeValue.emit({ toggle: this.value });
      }
    });
  }

  writeValue(value: boolean): void {
    this.toggleControl.setValue(value);
    if (this.value !== value) {
      super.writeValue(value);
    }
  }

  toggle(): void {
    this.value = !this.value;
    this.markAsDirty();
    this.changeValue.emit({ toggle: this.value });
  }
}
